import { Ellipsis, Icon } from '@advanza/ui'
import AutoRow from 'components/misc/AutoRow'
import React from 'react'

const UnpaidInvoiceStatus = ({
    unpaidInvoiceFollowUp,
    paytUrl,
    paytPausedAt,
    paytPausedByUser,
}) => {
    if (!unpaidInvoiceFollowUp) {
        return null
    }
    const {
        external_collector_invoice_id,
        failed_reason,
        troy_case_id,
        sent_to_troy,
        troy_collection_stopped,
        troy_settled,
    } = unpaidInvoiceFollowUp
    const title = JSON.stringify(unpaidInvoiceFollowUp, null, 2)

    const statusDots = {
        second_payment_announcement_sent: {
            icon: 'forward_to_inbox',
            color: 'blue',
        },
        second_payment_created: {
            icon: 'looks_two',
            color: 'green',
        },
        second_payment_failed: {
            icon: 'credit_card_off',
            color: 'red',
        },
        disabled: {
            icon: 'no_accounts',
            color: 'red',
        },
        follow_up_cancelled: {
            icon: 'error_med',
            color: 'orange',
        },
    }

    /**
     * An invoice paused at Payt looks identical to a stalled one, so it is called out
     * explicitly. Read live from Payt, so a manual pause there shows up here too.
     */
    const pausedTitle = paytPausedByUser
        ? `Payt dunning paused ${paytPausedAt} by ${paytPausedByUser}`
        : `Payt dunning paused ${paytPausedAt}`

    /**
     * Legacy Notify cases carry a UUID and are skipped by the Payt enrichment, so they
     * keep their original Notify link rather than losing navigation altogether.
     */
    const isLegacyNotifyId = /^[0-9a-f]{8}-[0-9a-f]{4}-/i.test(external_collector_invoice_id || '')
    const collectorUrl = (() => {
        if (paytUrl) {
            return paytUrl
        }
        if (isLegacyNotifyId) {
            return `https://notify.cm/facturen/${external_collector_invoice_id}`
        }
        return '#'
    })()

    /** A live Troy case is red; one we stopped or settled is no longer being chased. */
    const troyTitle = (() => {
        if (troy_settled) {
            return `Troy case ${troy_case_id} settled ${troy_settled}`
        }
        if (troy_collection_stopped) {
            return `Troy case ${troy_case_id} stopped ${troy_collection_stopped}`
        }
        return `Troy case ${troy_case_id}${sent_to_troy ? ` (sent ${sent_to_troy})` : ''}`
    })()
    const troyColor = (() => {
        if (troy_settled) {
            return '#1E7A4B'
        }
        if (troy_collection_stopped) {
            return '#6B7280'
        }
        return '#C0392B'
    })()

    return (
        <AutoRow>
            <span title={title}>
                <a title={title} target="_blank" href={collectorUrl}>
                    <Icon
                        orange={external_collector_invoice_id}
                        name={
                            external_collector_invoice_id ? 'monetization_on' : 'currency_exchange'
                        }
                        title={title}
                    />
                </a>{' '}
            </span>
            <div>
                <small title={failed_reason}>
                    <Ellipsis style={{ maxWidth: '5em' }}>{failed_reason}</Ellipsis>
                </small>
                <div>
                    {Object.keys(statusDots).map((key) => {
                        if (unpaidInvoiceFollowUp[key]) {
                            const { color, icon } = statusDots[key]
                            return (
                                <span
                                    style={{ cursor: 'pointer' }}
                                    key={key}
                                    title={key + ' ' + unpaidInvoiceFollowUp[key]}>
                                    <Icon fontSize={16} name={icon} style={{ color }} />
                                </span>
                            )
                        }
                    })}
                    {paytPausedAt && (
                        <span style={{ cursor: 'pointer' }} title={pausedTitle}>
                            <Icon fontSize={16} name="pause_circle" style={{ color: '#8E44AD' }} />
                        </span>
                    )}
                    {troy_case_id && (
                        <span style={{ cursor: 'pointer' }} title={troyTitle}>
                            <Icon fontSize={16} name="gavel" style={{ color: troyColor }} />
                        </span>
                    )}
                </div>
            </div>
        </AutoRow>
    )
}

export default UnpaidInvoiceStatus
